import {
	getOrdersByVisit,
	Order,
	Status,
	toWaitingList,
	useOrderInfo,
} from 'entities/orders';
import {
	restoreOrderToAppointment,
	restoreOrderToVisit,
} from 'entities/orders';
import { selectRestoreToVisitCountdown } from 'entities/settings';
import { FC } from 'react';
import { Fragment } from 'react/jsx-runtime';
import { usePaginationFilter } from 'shared/lib/pagination';
import { useAppDispatch, useAppSelector } from 'shared/lib/store';
import { withAsyncActionFeedback } from 'shared/ui/asyncAction';
import { ButtonContained } from 'shared/ui/buttons/buttonContained';
import { ButtonOutlined } from 'shared/ui/buttons/buttonOutlined';

const ActionButtonOutlinedWithFeedback =
	withAsyncActionFeedback(ButtonOutlined);
const ActionButtonContainedWithFeedback =
	withAsyncActionFeedback(ButtonContained);

interface OrderRestoreButtonsProps {
	status: Status;
	dateEnd: string;
	orderId: number;
	order: Order;
}
export const OrderRestoreButtons: FC<OrderRestoreButtonsProps> = ({
	status,
	dateEnd,
	orderId,
	order,
}) => {
	const filter = usePaginationFilter();
	const dispatch = useAppDispatch();
	const restoreCountdown = useAppSelector(selectRestoreToVisitCountdown);

	const restore = async () => {
		switch (status) {
			case 'visit_started':
				return await dispatch(
					restoreOrderToAppointment({ id: orderId }),
				);
			case 'visit_ended':
				return await dispatch(restoreOrderToVisit({ id: orderId }));
			case 'cancelled':
			case 'visit_missed':
				return await dispatch(toWaitingList({ id: orderId }));
			default:
				break;
		}
	};

	const { close } = useOrderInfo();

	const handleSuccess = async () => {
		if (filter) {
			await filter.fetchDataWithDispatch();
		} else if (status === 'visit_started') {
			await dispatch(getOrdersByVisit({}));
		}
		close();
	};

	const isDisableRestoreVisit = () => {
		if (restoreCountdown && dateEnd) {
			const restoreEndTime =
				new Date(dateEnd).getTime() + restoreCountdown * 1000;
			if (new Date().getTime() >= restoreEndTime) {
				return true;
			}
		}

		return false;
	};

	return (
		<Fragment>
			{(status === 'visit_started' || status === 'visit_ended') && (
				<ActionButtonOutlinedWithFeedback
					isFullWidth={true}
					onClick={restore}
					successToastLabel={
						status === 'visit_ended'
							? `Визит для гостя ${order?.person?.name} успешно востановлен`
							: `Вернули заказ для гостя ${order?.person?.name} в бронирование`
					}
					onSuccess={handleSuccess}
					children={
						status === 'visit_ended'
							? `Восстановить визит`
							: `Вернуть в бронирование`
					}
					disabled={isDisableRestoreVisit()}
				/>
			)}

			{(status === 'cancelled' || status === 'visit_missed') && (
				<ActionButtonContainedWithFeedback
					isFullWidth={true}
					onClick={restore}
					successToastLabel={`Бронирвоание для гостя ${order?.person?.name} востановлено`}
					onSuccess={handleSuccess}
				>
					Востановить бронирование
				</ActionButtonContainedWithFeedback>
			)}
		</Fragment>
	);
};
